import { AnimatePresence, motion } from 'framer-motion';

import { DrawerFooter } from '~/components/layout/drawer-footer';

type Props = React.PropsWithChildren<{
  open: boolean;
}>;

const NAV_BAR_HEIGHT_PX = '55px';

export function AppDrawer({ open, children }: Props) {
  return (
    <AnimatePresence mode="sync" initial={false}>
      {open ? (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.2 }}
          className="t-0 fixed left-0 z-40 w-full bg-primary-dark text-primary-foreground"
          style={{
            paddingTop: NAV_BAR_HEIGHT_PX,
            height: '100%',
          }}
        >
          <div className="flex h-full w-full flex-col justify-between px-10 py-8">
            {children}
            <DrawerFooter />
          </div>
        </motion.div>
      ) : null}
    </AnimatePresence>
  );
}
